/**
 *  sentry 初始化配置
 *
 */
const testConfig = {
  credit: {
    projectName: 'frontend-credit-sims-test',
    dsnUrl: 'http://13e8f32c6e3343a29b7a5fdb9ef3a622@sentry-relay.msxf.msxfyun.test/91',
  },
  withdraw: {
    projectName: 'frontend-withdraw-sims-test',
    dsnUrl: 'http://ef4522addb7b42f09b4367e908cb6643@sentry-relay.msxf.msxfyun.test/89',
  },
  repay: {
    projectName: 'frontend-repay-sims-test',
    dsnUrl: 'http://937c7add7e48487bafafeb6cae8ee65e@sentry-relay.msxf.msxfyun.test/92',
  },
  public: {
    projectName: 'frontend-public-sims-test',
    dsnUrl: 'http://38629c6f414f4776b91cc73d21dba308@sentry-relay.msxf.msxfyun.test/93',
  },
  pollen: {
    projectName: 'frontend-pollen-sims-test',
    dsnUrl: 'http://55d8ace34ae34610ac5a5c03cfccde60@sentry-relay.msxf.msxfyun.test/96',
  },
  vfast: {
    projectName: 'frontend-vfast-sims-test',
    dsnUrl: 'http://e4828f31148146da87f322d5fc728ac4@sentry-relay.msxf.msxfyun.test/97',
  },
  'ai-finance': {
    projectName: 'ai-finance-test',
    dsnUrl: 'https://07fe4c3a71c343afa679463ae2cff3d9@sentry-relay.msxf.com/282',
  },
};

const fillCommonAttr = () => {
  for (const projectName in testConfig) {
    testConfig[projectName] = Object.assign(testConfig[projectName], {
      ignoreErrors: [/^Loading chunk /, /^Loading CSS chunk /],
      tracesSampleRate: 1.0,
    });
  }
};
fillCommonAttr();

/**  生产环境配置 */
const commonIgnoreErrors = [
  /^Loading chunk /,
  /^Loading CSS chunk /,
  /Java object is gone /,
  /Java bridge method invocation error /,
  /dscb0 is not defined /,
  /MSWebMonitor.sendResource is not a function /,
];
const onlineConfig = {
  credit: {
    projectName: 'frontend-credit-sims',
    dsnUrl: 'https://bb27857adfce4457b2b23737fff20768@sentry-relay.msxf.com/289',
    ignoreErrors: [...commonIgnoreErrors],
    tracesSampleRate: 1.0,
  },
  withdraw: {
    projectName: 'frontend-withdraw-sims',
    dsnUrl: 'https://da2f3df2e42748109b07c6a87558e02d@sentry-relay.msxf.com/290',
    ignoreErrors: [...commonIgnoreErrors],
    tracesSampleRate: 1.0,
    isOnline: true,
  },
  repay: {
    projectName: 'frontend-repay-sims',
    dsnUrl: 'https://eade4c28e5eb4424a3c0e17773b3520a@sentry-relay.msxf.com/288',
    ignoreErrors: [...commonIgnoreErrors],
    tracesSampleRate: 1.0,
    isOnline: true,
  },
  public: {
    projectName: 'frontend-public-sims',
    dsnUrl: 'https://8135f9f591fc47889a21441e5cff6a85@sentry-relay.msxf.com/291',
    ignoreErrors: [...commonIgnoreErrors],
    tracesSampleRate: 1.0,
    isOnline: true,
  },
  pollen: {
    projectName: 'frontend-pollen-sims',
    dsnUrl: 'https://e70bda0be43a46eba22c7057cc9cbc11@sentry-relay.msxf.com/294',
    ignoreErrors: [...commonIgnoreErrors],
    tracesSampleRate: 1.0,
    isOnline: true,
  },
  vfast: {
    projectName: 'frontend-vfast-sims',
    dsnUrl: 'https://14940abd78404cc2b663b717b3ce1ce1@sentry-relay.msxf.com/292',
    ignoreErrors: [/^Loading chunk /, /^Loading CSS chunk /],
    tracesSampleRate: 1.0,
    isOnline: true,
  },
  'ai-finance': {
    projectName: 'ai-finance',
    dsnUrl: 'https://15ecef1cce96409193f673c375d8187b@sentry-relay.msxf.com/281',
    ignoreErrors: [/^Loading chunk /, /^Loading CSS chunk /],
    tracesSampleRate: 1.0,
    isOnline: true,
  },
};

export const getSentryConfig = (isOnline, appName) => {
  return (isOnline || process.env.NODE_ENV === 'production' ? onlineConfig : testConfig)?.[
    appName || process.env.APP_NAME
  ];
};
